<template>
  <transition name="slide-fade">
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="due-look" v-if="hide && !loading">
      <div class="look-nav">
        <div class="handle-wrapper" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          <div>返回</div>
        </div>
        <div class="look-nav-center">{{statusValue.materialName}}</div>
        <div class="handle-wrapper" style="opacity: 0">
          <div class="icon-font">&#xe612;</div>
          <div>返回</div>
        </div>
      </div>
      <div class="due-look-content">
        <div class="due-look-top">
          <div class="due-look-top-list">
            <div class="input-contain">
              <div class="input-title">烟叶简称：</div>
              <div class="input-wrapper">
                <input disabled="true" v-model="statusValue.materialName" placeholder=""/>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">物料代码：</div>
              <div class="input-wrapper" style="padding: 0.63vw">
                <div class="popover" style="text-align: left" v-if="statusValue.materialCode.length < 18">
                  {{statusValue.materialCode}}
                </div>
                <div class="detail-item" style="width: 100%;display: block" v-if="statusValue.materialCode.length >= 18">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="statusValue.materialCode">
                    <div class="popover" slot="reference">{{statusValue.materialCode}}</div>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.89vw">批次号：</div>
              <div class="input-wrapper">
                <input disabled="true" v-model="statusValue.materialBatchNum" placeholder=""/>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">库龄：</div>
              <div class="input-suffix-wrapper" style="margin-right: 0">
                <input disabled="true" v-model="statusValue.warehouseBuildTime" placeholder=""/>
                <div class="input-suffix">（天）</div>
              </div>
            </div>
          </div>
          <div class="due-look-top-list">
            <div class="input-contain">
              <div class="input-title">养护阶段：</div>
              <div class="input-wrapper">{{statusValue.maintainStage}}</div>
            </div>
            <div class="input-contain">
              <div class="input-title">仓库位置：</div>
              <div class="input-wrapper" style="padding: 0.63vw">
                <div class="popover" style="text-align: left" v-if="statusValue.siteName.length < 10">
                  {{statusValue.siteName}}
                </div>
                <div class="detail-item" style="width: 100%;display: block" v-if="statusValue.siteName.length >= 10">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="statusValue.siteName">
                    <div class="popover" slot="reference">{{statusValue.siteName}}</div>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="input-contain" style="opacity: 0">
              <div class="input-title">烟叶简称：</div>
              <div class="input-wrapper">
                <input disabled="true" placeholder=""/>
              </div>
            </div>
            <div class="input-contain" style="opacity: 0;">
              <div class="input-title">烟叶简称：</div>
              <div class="input-wrapper" style="margin-right: 0">
                <input disabled="true" placeholder=""/>
              </div>
            </div>
          </div>
        </div>
        <div class="due-look-bottom">
          <div class="due-look-title">养护历史</div>
          <div class="detail">
            <div class="detail-box" style="display:flex;flex-direction: column">
              <div class="detail-nav">
                <div class="detail-item" style="width: 10%">序号</div>
                <div class="detail-item" style="width: 10%">养护计划申请人</div>
                <div class="detail-item" style="width: 20%">申请时间</div>
                <div class="detail-item" style="width: 10%">养护阶段</div>
                <div class="detail-item" style="width: 10%">审核人员</div>
                <div class="detail-item" style="width: 10%">养护时间</div>
                <div class="detail-item" style="width: 5%">审核情况</div>
                <div class="detail-item" style="width: 15%">审核时间</div>
                <div class="detail-item" style="width: 10%">备注</div>
              </div>
              <div class="detail-content" style="flex: 1;padding-bottom: 0;overflow: auto">
                <div class="detail-list-wrapper" v-for="(data,index) in statusValue.planHistoryList" :key="index">
                  <div class="detail-item" style="width: 10%">{{index+1}}</div>
                  <div class="detail-item" style="width: 10%">{{data.principalName}}</div>
                  <div class="detail-item" style="width: 20%">{{getRenderTime(data.createdTime)}}</div>
                  <div class="detail-item" style="width: 10%">{{getMaintainStageData(data.maintainStage)}}</div>
                  <div class="detail-item" style="width: 10%">{{data.approverName}}</div>
                  <div class="detail-item" style="width: 10%">{{data.maintainDays}}</div>
                  <div class="detail-item" style="width: 5%" :class="data.approveStatus === 1 ? 'color-green' : data.approveStatus === 2 ? 'color-red' : 'color-set'">{{getApproveStatus(data.approveStatus)}}</div>
                  <div class="detail-item" style="width: 15%">{{getRenderTime(data.approverTime)}}</div>
                  <div class="detail-item" style="width: 10%;display: block" v-if="data.remark.length < 10">{{data.remark}}</div>
                  <div class="detail-item" style="width: 10%;display: block" v-if="data.remark.length >= 10">
                    <el-popover
                      placement="top"
                      title=""
                      trigger="hover"
                      :content="data.remark">
                      <div class="popover" slot="reference">{{data.remark}}</div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {queryMaintainPlanAndHistorysById} from '../../../api/maintain'
import {daysDistance, renderTime} from '../../../tools/methods'
export default {
  name: 'DueLook',
  data () {
    return {
      loading: true,
      hide: false,
      statusValue: {}
    }
  },
  created () {
    let id = this.$route.query.id
    let _this = this
    setInterval(function () {
      _this.hide = true
    }, 100)
    queryMaintainPlanAndHistorysById({id: id}).then(res => {
      console.log(res.data)
      this.statusValue = res.data
      this.statusValue.warehouseBuildTime = daysDistance(this.statusValue.warehouseBuildTime)
      this.statusValue.maintainStage = this.getMaintainStageData(this.statusValue.maintainStage)
      this.loading = false
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getRenderTime: function (time) {
      return renderTime(time)
    },
    getApproveStatus: function (approveStatus) {
      if (approveStatus === 0) {
        return '未审核'
      } else if (approveStatus === 1) {
        return '已审核'
      } else if (approveStatus === 2) {
        return '已拒绝'
      }
    },
    getMaintainStageData: function (maintainStage) {
      if (maintainStage === '01') {
        return '自然醇化阶段'
      } else if (maintainStage === '02') {
        return '防霉杀虫阶段'
      } else if (maintainStage === '03') {
        return '气调醇化阶段'
      } else {
        return '气调保质阶段'
      }
    },
    backPath: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
@import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/DueLook.vue